"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FormatPhoneNumber = require("../../../../utils/FormatPhoneNumber");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _text_input = require("../../text_input");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PhoneNumberInput = function PhoneNumberInput(_ref) {
  var register = _ref.register,
      errors = _ref.errors,
      name = _ref.name,
      required = _ref.required,
      country = _ref.country;
  var error = false;
  var helperText = '';

  if (errors[name]) {
    error = true;
    helperText = errors[name].message;
  }

  var handlePhoneInput = function handlePhoneInput(e) {
    var phoneInput = e.target;
    var inputValue = e.target.value;
    phoneInput.value = (0, _FormatPhoneNumber.FormatPhoneNumber)(inputValue);
  };

  return /*#__PURE__*/_react["default"].createElement(_text_input.TextInput, {
    cypressClass: "phone-number-input",
    helperText: helperText,
    error: error,
    type: "tel",
    onChange: handlePhoneInput,
    label: "Phone",
    name: name,
    maxLength: country === 'NZ' ? 11 : 10,
    register: register({
      required: required ? 'Missing Phone Number' : false,
      pattern: {
        value: /^0(\d{7,10})/i,
        message: 'Please enter a valid phone number'
      }
    })
  });
};

PhoneNumberInput.propTypes = {
  /**
   * Object containing the errors from this input field.
   */
  errors: _propTypes["default"].object,

  /**
   * The name of the phone input field. Will default to 'phoneNumber' if no value is passed.
   */
  name: _propTypes["default"].string.isRequired,

  /**
   * Country
   */
  country: _propTypes["default"].string.isRequired,

  /**
   * A boolean that determines if the name field is required or not.
   */
  required: _propTypes["default"].bool.isRequired,

  /**
   * A function that gets passed for the useForm hook from react-hook-form to register an input
   *
   */
  register: _propTypes["default"].func.isRequired
};
PhoneNumberInput.defaultProps = {
  errors: {},
  register: function register() {},
  required: true,
  name: 'phoneNumber',
  country: 'AU'
};
var _default = PhoneNumberInput;
exports["default"] = _default;